import { PayloadAction } from "@reduxjs/toolkit";
import { LocationState } from "./interfaces";

export const reducers = {
    setLocation: (state: LocationState, action: PayloadAction<any>) => {
        state.dynsCards = action.payload.dynsCards;
        state.field = action.payload.field;
        state.fieldActivities = action.payload.fieldActivities;
        state.fluidLevels = action.payload.fluidLevels;
        state.locationId = action.payload.locationId;
        state.projectId = action.payload.projectId;
        state.locationName = action.payload.locationName;
        state.locationSetPoints = action.payload.locationSetPoints;
        state.locationTags = action.payload.locationTags;
        state.pot = action.payload.pot;
        state.requirements = action.payload.requirements;
        state.zone = action.payload.zone;
        state.wellboreDiagram = action.payload.wellboreSchematics;
        state.files = [];
        state.method = action.payload.method;
        state.lastStatusConditions = action.payload.lastStatusConditions;
        state.waterTests = action.payload.waterTests;
        state.categoriesChanges = action.payload.categoriesChanges;
        state.subsurfaceJobs = action.payload.subsurfaceJobs;
        state.optimizationRequirements = action.payload.optimizationRequirements;
    },

    setLocationSetPoint: (state: LocationState, action: PayloadAction<any>) => {
        state.locationSetPoints = action.payload;
    },

    setLocationCategoriesChanges: (state: LocationState, action: PayloadAction<any>) => {
        state.categoriesChanges = action.payload;
    },
};

